/*
 * @Author: 陈大仙人
 * @Date: 2024-01-25 18:10:16
 * @LastEditors: 陈大仙人
 * @LastEditTime: 2025-01-07 10:14:07
 * @FilePath: /akx-pc-main/src/config.js
 */
module.exports = {
    baseURL: (function(){
        if (process.env.NODE_ENV === 'development') {
            return 'https://akx-dev.boogcloud.com/akx/bubu'
        } else if (process.env.NODE_ENV === 'production') {
            return 'https://ai.kxkx888.com/aikuaixiao/bubu'
        }
    })()
}